import React from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

export function confirmationDialog(options, callback) {
  return confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div className="box">
          <label className="label">{options.title}</label>
          <p className="">{options.text}</p>

          <div className="buttons mt-4">
            <button
              className={`button is-${options.positiveColor} is-small`}
              onClick={() => {
                callback();
                onClose();
              }}
            >
              {options.positiveText}
            </button>
            <button
              className={`button is-${options.negativeColor} is-small`}
              onClick={() => onClose()}
            >
              {options.negativeText}
            </button>
          </div>
        </div>
      );
    },
  });
}
